(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pango-contact-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.contact-form__form').forEach((form) => {
    const select = form.querySelector('#ContactForm-variant');
    const dataEl = form.querySelector('[data-contact-variants]');
    const priceEl = form.querySelector('[data-contact-price-current]');
    const compareEl = form.querySelector('[data-contact-price-compare]');
    if (!select || !dataEl || !priceEl) return;

    let variants = {};
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const update = () => {
      const option = select.options[select.selectedIndex];
      const id = option?.dataset.variantId;
      const variant = id ? variants[id] : null;
      if (!variant) return;

      priceEl.textContent = variant.price;

      if (compareEl) {
        compareEl.textContent = variant.compare_at_price || '';
        compareEl.hidden = !variant.on_sale;
      }

      priceEl.closest('[data-contact-price]')?.classList.toggle('is-sold-out', !variant.available);
    };

    select.addEventListener('change', update);
    update();
  });
  } catch(e) { console.error(e); }
})();

})();
